import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { navSections } from "./nav-config";
import { useAuth } from "@/hooks/use-auth";

export function Sidebar() {
  const { session } = useAuth();

  return (
    <aside className="hidden md:flex md:w-60 md:flex-col md:border-r md:border-line md:bg-surface">
      <div className="px-5 pt-6 pb-5">
        <div className="flex items-center gap-2">
          <div className="grid h-7 w-7 place-items-center rounded-md bg-accent text-accent-fg text-sm font-semibold">
            O
          </div>
          <div className="flex flex-col leading-tight">
            <span className="text-sm font-semibold text-ink">OpenClaw</span>
            <span className="text-xs text-ink-faint">Sales control</span>
          </div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 pb-4 scrollbar-thin">
        {navSections.map((section) => (
          <div key={section.label} className="mb-5">
            <div className="px-2 pb-1.5 text-xs font-medium uppercase tracking-wider text-ink-faint">
              {section.label}
            </div>
            <ul className="flex flex-col gap-0.5">
              {section.items.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.to === "/"}
                    className={({ isActive }) =>
                      cn(
                        "group flex items-center gap-2.5 rounded-md px-2 py-1.5 text-sm transition-colors duration-[160ms] ease-out-quart",
                        isActive
                          ? "bg-accent-soft text-accent-strong font-medium"
                          : "text-ink-muted hover:bg-surface-muted hover:text-ink"
                      )
                    }
                  >
                    <item.icon className="h-4 w-4 flex-shrink-0" strokeWidth={1.75} />
                    <span className="truncate">{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      {session && (
        <div className="border-t border-line px-5 py-3">
          <div className="flex items-center gap-2.5">
            <div className="grid h-7 w-7 place-items-center rounded-full bg-surface-muted text-xs font-medium text-ink-muted">
              {(session.full_name || session.username).slice(0, 1).toUpperCase()}
            </div>
            <div className="min-w-0 leading-tight">
              <div className="truncate text-sm font-medium text-ink">
                {session.full_name || session.username}
              </div>
              <div className="truncate text-xs text-ink-faint">{session.role || "admin"}</div>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
}
